import { getObjectEntries } from "./GetObjectEntries.js";
function* getObjectEnumerableKeysGenerator(obj) {
  const keys = getObjectEntries(obj);
  for (const key of keys) {
    const desc = Object.getOwnPropertyDescriptor(obj, key);
    if (desc == null ? void 0 : desc.enumerable) yield key;
  }
}
function getObjectEnumerableKeys(obj) {
  return [...getObjectEnumerableKeysGenerator(obj)];
}
export {
  getObjectEnumerableKeys
};
//# sourceMappingURL=GetObjectEnumerableKeys.js.map
